export function genRandomKey() {
  var randomKey = Math.random().toString(36).slice(2);
  return randomKey;
}